import NewBooksInMonth from './NewBooksInMonth';

export default NewBooksInMonth;
